import styled from 'styled-components';

/**
 * The text half of a row. `min-width: 0` is what lets the title truncate -
 * without it the flex child refuses to shrink and the whole line wraps into
 * the tall broken column the mobile view had.
 */
export const RowSummary = styled.div`
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

export const Title = styled.h5`
  margin: 0;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.darkGray};
`;

/**
 * The type label and the target pills, on one wrapping line.
 *
 * Capped in the component rather than here: six platforms of chips would be
 * three lines on a phone, which is taller than everything else the row says
 * put together.
 */
export const TargetRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
`;

export const TypeLabel = styled.span`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.lightGray};
`;

export const RowActions = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 800px) {
    gap: 8px;
  }
`;
